import { getPlanCalendarDays, getDateKey } from "./planDates";

function getDateKeyForDayName(dayName) {
  const weekDays = getPlanCalendarDays(0);
  const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const dayIndex = dayNames.indexOf(dayName);
  if (dayIndex === -1) return dayName;
  const date = weekDays[dayIndex];
  return date ? getDateKey(date) : dayName;
}

export function getOrderedMealsForDay(plan, completedMeals, day) {
  const dateKey = getDateKeyForDayName(day);
  const dayMeals = plan[dateKey] || {};
  const mealOrder = ["breakfast", "lunch", "dinner"];

  const meals = mealOrder.map((mealType) => {
    const meal = dayMeals[mealType];
    return {
      mealType,
      meal,
      isCompleted: completedMeals[`${dateKey}-${mealType}`] || false
    };
  });

  const firstUncompletedIndex = meals.findIndex(
    (item) => item.meal && !item.isCompleted
  );

  if (firstUncompletedIndex === -1) {
    const dinnerIndex = meals.findIndex((item) => item.mealType === "dinner");
    if (dinnerIndex > -1) {
      return [
        meals[dinnerIndex],
        meals[(dinnerIndex + 2) % 3],
        meals[(dinnerIndex + 1) % 3]
      ];
    }
    return meals;
  }

  return [
    meals[firstUncompletedIndex],
    meals[(firstUncompletedIndex + 2) % 3],
    meals[(firstUncompletedIndex + 1) % 3]
  ];
}

export function getMealsForDayInFixedOrder(plan, completedMeals, day) {
  const dateKey = getDateKeyForDayName(day);
  const dayMeals = plan[dateKey] || {};
  const mealOrder = ["breakfast", "lunch", "dinner"];

  return mealOrder.map((mealType) => ({
    mealType,
    meal: dayMeals[mealType],
    isCompleted: completedMeals[`${dateKey}-${mealType}`] || false
  }));
}